import { Modal, GIButton } from 'app-components';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { StyledModalContent } from '../styles';

export default function AdminPlansDrugsCommonModal(props) {
    const {
        actions: { hideModal },
        modal: {
            modalData: { status, modalBodyContent, modalHeaderId },
        },
    } = props;

    const onCloseModal = () => {
        hideModal();
    };

    return (
        <Modal id="admin-plan-drugs-common-modal">
            <Modal.Header id="self-designation-otp-modal-header" titleId={modalHeaderId} onHide={onCloseModal} />
            <Modal.Body id="self-designation-otp-modal-body">
                <StyledModalContent $statusMessage={status}>
                    <FormattedMessage id={modalBodyContent} />
                </StyledModalContent>
            </Modal.Body>
            <Modal.Controls>
                <GIButton
                    id="modalSubmitButton"
                    labelId="button.ok"
                    variant="primary"
                    onClickHandler={onCloseModal}
                />
            </Modal.Controls>
        </Modal>
    );
}
